import { useMutation } from "@apollo/client";
import { FunctionComponent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AdyenRoutesName } from "routes/route-names";
import { getRoutePath } from "routes/route-utils";
import Button from "../Button/Button";
import InputField from "../InputField/InputField";
import { createPasswordRecoveryRequestQuery } from "./mutations";

const ForgotPassword: FunctionComponent = () => {
  //#region hooks
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  //#endregion

  //#region API CALLS
  const [createPasswordRecoveryRequest] = useMutation(
    createPasswordRecoveryRequestQuery,
    {
      onCompleted: (data) => {
        setButtonDisabled(false);
        toast.success(`Password recovery mail is sent to ${email}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClose: () => {
            navigate(getRoutePath(AdyenRoutesName.LOGIN));
          },
        });
      },
      onError: (error) => {
        setButtonDisabled(false);
        toast.error(error.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      },
    }
  );
  //#endregion

  return (
    <>
      <form className="login__form">
        <InputField
          label="Email"
          type="text"
          required
          autoFocus={true}
          placeholder="Enter your email"
          icon={""}
          className={""}
          onChange={(e: any) => setEmail(e.target.value)}
          value={email}
          autoComplete="new-password"
        />
        <Button
          type="submit"
          className="button--primary button--block"
          content="Send Reset Password Link"
          icon={""}
          onClick={(event: any) => {
            event.preventDefault();
            setButtonDisabled(true);
            createPasswordRecoveryRequest({ variables: { email } });
          }}
          disabled={buttonDisabled}
        ></Button>
        <Button
          type="button"
          className="button--secondary button--block"
          content="Back to Login"
          icon={""}
          onClick={() => {
            navigate(getRoutePath(AdyenRoutesName.LOGIN));
          }}
        ></Button>
      </form>
    </>
  );
};

export default ForgotPassword;
